import { ref, toRefs } from 'vue';
import { defineStore } from 'pinia';
import useActions from './actions';
import useCommonGetters from '../common-getters';
import { ISupportState } from './models';

export const useSupportStore = defineStore('support', () => {
  const state = ref(<ISupportState>{
    data: null,
    isEditModeActive: false,
  });

  return {
    ...toRefs(state.value),
    ...useCommonGetters<ISupportState>(state),
    ...useActions(state),
  };
});
